<template>
  <div class="download-wrapper">
    <div class="banner">
      <div class="container">
        <div class="logo">
          <router-link to="/"><img src="../../../assets/img/download/logo.png"></router-link>
        </div>
        <div class="download-buttons">
          <ul>
            <li>
              <a href="https://itunes.apple.com/cn/app/id1059667773" target="_blank" class="ios">Iphone下载</a>
            </li>
            <li>
              <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.zaiart.yi" target="_blank" class="android">Android下载</a>
            </li>
          </ul>
          <div class="qr-code"><img src="../../../assets/img/download/qr_code.png" width="170" height="170"></div>
        </div>
        <div class="phone">
          <div class="phone-left"><img src="../../../assets/img/download/phone_01.png"></div>
          <div class="phone-right"><img src="../../../assets/img/download/phone_02.png"></div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="section download-bg1">
        <div class="container is-clearfix">
          <div class="content is-right">
            <span class="d"></span>
            <h2 class="title">
              <em>艺术</em>展览的海量汇集</h2>
            <p class="text">在艺提供覆盖全球八十个城市的展览资讯， 涵盖画廊、 美术馆、拍卖行三大系统， 提供超过五百个兴趣分类标签的检索和订阅。</p>
          </div>
          <div class="picture is-left"><img src="../../../assets/img/download/app_01.png" width="420" height="718"></div>
        </div>
      </div>
      <div class="section download-bg1">
        <div class="container is-clearfix">
          <div class="content is-left">
            <span class="d"></span>
            <h2 class="title">
              <em>艺术</em>点评的活跃平台</h2>
            <p class="text">在艺鼓励用户以图文或视频笔记的方式分享对艺术展览、作品的见解和评价，为艺术市场注入多元价值判断标准,也为广大艺术爱好者提供专业的艺术点评平台。</p>
          </div>
          <div class="picture is-right"><img src="../../../assets/img/download/app_02.png" width="420" height="718"></div>
        </div>
      </div>
      <div class="section download-bg1">
        <div class="container is-clearfix">
          <div class="content is-right">
            <span class="d"></span>
            <h2 class="title">
              <em>艺术</em>交友的高端社区</h2>
            <p class="text">在艺社区凝聚了一批艺术家、策展人、 评论家、 学者、 藏家、 鉴定专家、 企业家、艺术金融从业者和艺术爱好者， 彼此促进， 以艺会友。</p>
          </div>
          <div class="picture is-left"><img src="../../../assets/img/download/app_03.png" width="420" height="718"></div>
        </div>
      </div>
      <div class="section download-bg1">
        <div class="container is-clearfix">
          <div class="content is-left">
            <span class="d"></span>
            <h2 class="title">
              <em>艺术</em>服务的全能顾问</h2>
            <p class="text">用户可以根据自己的地理定位搜索附近的展览，并可以根据展期安排行程。 在艺特别为拍卖与收藏业内用户打造了印款查询的功能， 以便迅速鉴别作品真伪。</p>
          </div>
          <div class="picture is-right"><img src="../../../assets/img/download/app_04.png" width="420" height="718"></div>
        </div>
      </div>
      <div class="section download-bg2">
        <div class="container has-text-centered">
          <h2 class="title" style="margin-top:64px;">在艺App，爱
            <em>艺术</em>的人都在这里</h2>
          <div class="qr-code"><img src="../../../assets/img/download/qr_code.png" width="212">
            <h4>扫码立即下载</h4>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
    <app-back-top></app-back-top>
  </div>
</template>
<script>
import '@/assets/css/download.css'
import footer from '../common/footer'
import BackTop from '../common/backTop'

export default {
  components: { 'app-footer': footer, 'app-back-top': BackTop },
  data() {
    return { items: [], entered: [] }
  },
  methods: {
    isEntered(index) {
      return this.entered.indexOf(index) > -1
    },
    scrollCallback() {
      let scrollTop = window.pageYOffset
      for (let i = 0; i < this.items.length; i++) {
        if (scrollTop + 650 > this.items[i].offsetTop) {
          this.setEnter(i)
        }
      }
    },
    setEnter: function(index) {
      if (!this.isEntered(index)) {
        this.entered.push(index)
        this.items[index].classList.add('enter')
      }
    },
    bindScrollInView() {
      window.addEventListener('scroll', this.scrollCallback)
      this.scrollCallback()
    }
  },
  mounted() {
    this.items = this.$el.querySelectorAll('div.section')
    this.$nextTick(function() {
      this.bindScrollInView()
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollCallback)
  }
}
</script>
